import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getRetailDiscount } from '../wf/discountHelpers';
import ExpandableArea from './ExpandableArea';
const InstoreDiscountInstructions = (props) => {
    var _a;
    if ((_a = props.platforms) === null || _a === void 0 ? void 0 : _a.some(p => p.name !== 'SQUARE')) {
        return (_jsx(ExpandableArea, { title: "Add discounts to your POS", children: _jsx(OtherInstoreDiscountInstructions, Object.assign({}, props)) }));
    }
    else {
        return null;
    }
};
const InstoreDiscountList = (props) => {
    var _a;
    return (_jsx(React.Fragment, { children: (_a = props.membershipTiers) === null || _a === void 0 ? void 0 : _a.map((membership, i) => {
            var _a, _b;
            return ((_a = getRetailDiscount(membership.discounts)) === null || _a === void 0 ? void 0 : _a.percentage) && (_jsxs("li", { children: ["Name: ", membership.name, ", Discount: ", (_b = getRetailDiscount(membership.discounts)) === null || _b === void 0 ? void 0 : _b.percentage, "% off"] }));
        }) }));
};
const OtherInstoreDiscountInstructions = (props) => {
    return (_jsxs("article", { className: "prose max-w-none mt-4 pt-4 border-t-2 mb-2", children: [_jsx("p", { children: "Open your store dashboard:" }), _jsxs("ul", { children: [_jsx("li", { children: "Navigate to Coupon or Discount settings" }), _jsx("li", { children: "Enter these discounts:" }), _jsx(InstoreDiscountList, Object.assign({}, props))] })] }));
};
export default InstoreDiscountInstructions;
